module.exports = __webpack_public_path__ + "static/media/communication.5d5dc6d8.svg";